import {navigation} from "./Navigation";

export class NavigationPlugin {
    public install(Vue) {
        Vue.prototype.$navigation = navigation;
    }
}
